"use client";

import { useRef } from "react";
import { useMediaSelector } from "media-chrome/react/media-store";
import { useInView } from "motion/react";
import HlsPlayer from "hls-video-element/react";

import { cn } from "@marketing-sites/utils/cn";
import { useMediaQuery } from "@marketing-sites/hooks/use-media-query";

import { useMediaPlayerContext } from "./media-player.provider";
import { useHasPlayedOnce } from "./media-player.hooks";

export const PreviewVideo = () => {
  const hasPlayedOnce = useHasPlayedOnce();
  const { video, previewVideo } = useMediaPlayerContext();
  const isPaused = useMediaSelector((state) => state?.mediaPaused);
  const isMobile = useMediaQuery("(max-width: 767px)");
  const containerRef = useRef<HTMLDivElement>(null);
  const isNearViewport = useInView(containerRef, { margin: "200px" });

  // Only render if there's a preview video to show
  if (!previewVideo?.url) return null;

  return (
    <div
      ref={containerRef}
      className={cn(
        "z-(--z-index-slot-thumbnail) absolute inset-0 flex h-full w-full items-center justify-center overflow-hidden",
        hasPlayedOnce && "pointer-events-none opacity-0",
        previewVideo?.showWhenPaused &&
          isPaused &&
          "pointer-events-auto opacity-100",
      )}
    >
      {isNearViewport && (
        <HlsPlayer
          src={
            typeof previewVideo.url === "string"
              ? previewVideo.url
              : isMobile
                ? previewVideo.url.mobile
                : previewVideo.url.desktop
          }
          autoplay
          muted
          loop
          playsInline
          className="absolute inset-0 h-full w-full [--media-object-fit:cover]"
          poster={video?.poster}
          defaultMuted
          volume={0}
        />
      )}
    </div>
  );
};
